import type { Theme } from '@/ui/primitives';

type ThemeTypographyResolver = (theme: Theme) => string | number;

type TypographyTextSx = {
  fontSize?: ThemeTypographyResolver;
  lineHeight?: ThemeTypographyResolver;
};

type AuthSecondaryTextSx = TypographyTextSx & {
  textAlign: 'center';
};

type AuthTextFieldSx = {
  '& .MuiInputBase-root, & .MuiOutlinedInput-root': TypographyTextSx & {
    backgroundColor: 'var(--surface-page)';
  };
  '& .MuiInputBase-root.Mui-disabled, & .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: 'var(--surface-page) !important';
    opacity: 1;
  };
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider';
  };
  '& .MuiInputBase-input, & .MuiOutlinedInput-input, & input': TypographyTextSx;
  '& .MuiInputBase-input:-webkit-autofill, & .MuiOutlinedInput-input:-webkit-autofill, & input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 100px var(--surface-page) inset !important';
    WebkitTextFillColor: 'currentColor !important';
    caretColor: 'currentColor';
    transition: 'background-color 9999s ease-out';
  };
  '& .MuiInputBase-input::placeholder, & .MuiOutlinedInput-input::placeholder, & input::placeholder': TypographyTextSx & {
    color: 'text.secondary';
    opacity: 1;
  };
};

const resolveSubtitle1FontSize = (theme: Theme): string | number =>
  theme.typography.subtitle1.fontSize ?? 'inherit';

const resolveSubtitle1LineHeight = (theme: Theme): string | number =>
  theme.typography.subtitle1.lineHeight ?? 'normal';

export const authSecondaryTextSx: AuthSecondaryTextSx = {
  textAlign: 'center',
  lineHeight: (theme: Theme) => resolveSubtitle1LineHeight(theme),
};

export const authFieldLabelSx: TypographyTextSx = {
  lineHeight: (theme: Theme) => resolveSubtitle1LineHeight(theme),
};

export const authTextFieldSx: AuthTextFieldSx = {
  '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
    backgroundColor: 'var(--surface-page)',
    fontSize: (theme: Theme) => resolveSubtitle1FontSize(theme),
    lineHeight: (theme: Theme) => resolveSubtitle1LineHeight(theme),
  },
  '& .MuiInputBase-root.Mui-disabled, & .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: 'var(--surface-page) !important',
    opacity: 1,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
  },
  '& .MuiInputBase-input, & .MuiOutlinedInput-input, & input': {
    fontSize: (theme: Theme) => resolveSubtitle1FontSize(theme),
    lineHeight: (theme: Theme) => resolveSubtitle1LineHeight(theme),
  },
  '& .MuiInputBase-input:-webkit-autofill, & .MuiOutlinedInput-input:-webkit-autofill, & input:-webkit-autofill':
    {
      WebkitBoxShadow: '0 0 0 100px var(--surface-page) inset !important',
      WebkitTextFillColor: 'currentColor !important',
      caretColor: 'currentColor',
      transition: 'background-color 9999s ease-out',
    },
  '& .MuiInputBase-input::placeholder, & .MuiOutlinedInput-input::placeholder, & input::placeholder':
    {
      color: 'text.secondary',
      fontSize: (theme: Theme) => resolveSubtitle1FontSize(theme),
      lineHeight: (theme: Theme) => resolveSubtitle1LineHeight(theme),
      opacity: 1,
    },
};
